import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LanguageService } from 'src/app/modules/shared/services/language.service';
import { ProjectsService } from 'src/app/modules/shared/services/projects.service';

@Component({
  standalone: false,
  selector: 'app-project-dialog',
  templateUrl: './project-dialog.component.html',
  styleUrls: ['./project-dialog.component.css']
})
export class ProjectDialogComponent implements OnInit {
  variables: any;
  local_data: any;
  projectFormGroup: any;
  invalidInput1: boolean = false;
  invalidInput2: boolean = false;
  invalidInput3: boolean = false;
  invalidInput4: boolean = false;
  errorMessage1: string = '';
  errorMessage2: string = '';
  errorMessage3: string = '';
  errorMessage4: string = '';
  regions: any = [];
  disableName: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProjectDialogComponent>,
    private _formBuilder: FormBuilder,
    private languageService: LanguageService,
    private _snackBar: MatSnackBar,
    private projectService: ProjectsService
  ) {
    this.local_data = { ...data };

    this.projectFormGroup = this._formBuilder.group({
      nameCtrl: ['']
    });
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    if (this.local_data.type === "ADD") {
      this.projectFormGroup = this._formBuilder.group({
        nameCtrl: ['', Validators.required],
        regionCtrl: ['', Validators.required],
        maintenancePctCtrl: [this.local_data.maintenancePct ?? 0, [Validators.required, Validators.min(0), Validators.max(100)]],
      });
      this.regions = [
        this.variables.global,
        this.variables.portugal,
        this.variables.spain
      ];
    }
    else if (this.local_data.type === "EDIT") {
      this.projectFormGroup = this._formBuilder.group({
        nameCtrl: [this.local_data.name, Validators.required],
        activeCtrl: [this.local_data.active, Validators.required],
        regionCtrl: [this.local_data.region, Validators.required],
        maintenancePctCtrl: [this.local_data.maintenancePct ?? 0, [Validators.required, Validators.min(0), Validators.max(100)]],
      });
      this.regions = [
        this.variables.global,
        this.variables.portugal,
        this.variables.spain
      ];
    }

  }

  doAction() {



    if (this.projectFormGroup.valid) {

      if (this.local_data.type === "ADD") {
        this.projectService.addProject(this.projectFormGroup.value.nameCtrl, this.projectFormGroup.value.regionCtrl, this.projectFormGroup.value.maintenancePctCtrl ?? 0).subscribe((data: any) => {
          if (data) {
            if (data.success) {
              this._snackBar.open(this.variables.successfullyAddedProject, '', {
                duration: 4000,
                panelClass: ['successful-snackbar']
              });

              this.dialogRef.close({ data: { success: true }, projId: data.id });
            }
            else {

              this.dialogRef.close({ data: { success: false, error: data.message } });
            }
          }
        },
          (error: any) => {
            console.error('Erro ao adicionar projeto:', error);

            this._snackBar.open(this.variables.alreadyExists, '', {
              duration: 4000,
            });
          }
        )
      }
      else if (this.local_data.type === "EDIT") {
        this.projectService.editProject(this.local_data.projectId, this.projectFormGroup.value.nameCtrl, this.projectFormGroup.value.regionCtrl, this.projectFormGroup.value.activeCtrl, this.projectFormGroup.value.maintenancePctCtrl ?? 0).subscribe((data: any) => {
          if (data) {
            if (data.success) {
              this._snackBar.open(this.variables.successfullyEditedProject, '', {
                duration: 4000,
                panelClass: ['successful-snackbar']
              });

              this.dialogRef.close({ data: { success: true } });
            }
            else {
              this.dialogRef.close({ data: { success: false, error: data.message } });
            }
          }
        },
          (error: any) => {
            console.error('Erro ao editar projeto:', error);

            switch (error.error.message) {
              case 'Project not found':
                this._snackBar.open(this.variables.project + this.variables.notFound, '', {
                  duration: 4000,
                });
                break;
              case 'A project with this name already exists':
                this._snackBar.open(this.variables.alreadyExists, '', {
                  duration: 4000,
                });
                break;
              case 'Access denied to this project':
                this._snackBar.open(this.variables.notAuthorized + "for this proj", '', {
                  duration: 4000,
                });
                break;
              case 'Admins can only edit their own projects':
                this._snackBar.open(this.variables.adminsCanOnlyEditOwnProjects, '', {
                  duration: 4000,
                });
                break;
              case 'Users are not allowed to edit projects':
                this._snackBar.open(this.variables.notAllowedEditProjects, '', {
                  duration: 4000,
                });
                break;
            }
          }
        )
      }
    }
    else {
      this.projectFormGroup.markAllAsTouched();  // trigger error messages
      return;
    }

  }

  changeClient(value: any) {
    this.local_data.region = value;
  }

}
